import React from 'react';
import Hit from '../Hit/Hit';
import MetaBar from '../MetaBar/MetaBar';
import HtmlTitle from '../HtmlTitle/HtmlTitle';

export default function ResultsLoading(props) {
    const hits = new Array(props.maxResults);
    hits.fill(true);

    return (
        <div className="Results">
            <MetaBar />
            <HtmlTitle />
            <div className="ScrollListener ScrollListener--placeholder">
                <div className="HitCollection HitCollection--placeholder">
                    {hits.map((a, i) => (
                        <Hit key={i} />
                    ))}
                </div>
            </div>
        </div>
    );
}
